
<GenAILayout class="intent-selection">
  <template #nav>
    <cvt-top-nav-bar
      mode="LIGHT"
      :route="genAISelectTemplate"
      variant="embedded"
      :class="'cvt-top-nav-bar'"
      template-name="Let's get started!"
      :on-genai-wizard="true"
      :fixed="true"
      :light-logo="logo"
      :dark-logo="logo"
      :type="orgName"
      @back="navigateToChooseATemplate"
    />
  </template>

  <div class="intent-sidebar superfunnel-pane">
    <cvt-button
      :disabled="loading"
      class="back-btn"
      text=""
      icon="cvt-icon-arrow-left-05"
      @click="goBack"
    />

    <section>
      <div class="superfunnel-form">
        <label class="superfunnel-form__label">
          Enter your business name <span>*</span>
        </label>
        <cvt-input
          :value="businessName"
          :placeholder="'Enter your business name'"
          :required="true"
          class="superfunnel-form__input"
          @input="(e) => onBusinessNameInput(e.target.value)"
        />
        <p v-if="businessNameError" class="superfunnel-form__error">
          Business name is required.
        </p>

        <label class="superfunnel-form__label">
          Select your business industry <span>*</span>
        </label>
        <cvt-select
          class="superfunnel-form__input"
          mode="dropdown"
          :background-mode="'LIGHT'"
          :multiple="false"
          :value="businessIndustry"
          :placeholder="'Select your business industry'"
          @input="onBusinessIndustryChange"
        >
          <option
            v-for="category in industries"
            :key="category.value"
            :value="category.value"
          >
            {{ category.label }}
          </option>
        </cvt-select>
        <p v-if="businessIndustryError" class="superfunnel-form__error">
          Business industry is required.
        </p>

        <label class="superfunnel-form__label">
          Provide a brief description of your business <span>*</span>
        </label>
        <cvt-input
          type="textarea"
          rows="4"
          :value="businessDescription"
          :placeholder="'Provide a brief description of your business'"
          :required="true"
          class="superfunnel-form__input"
          @input="(e) => onBusinessDescriptionInput(e.target.value)"
        />
        <p v-if="businessDescriptionError" class="superfunnel-form__error">
          Business description is required.
        </p>

        <cvt-button
          class="superfunnel-form__submit"
          text="Generate Landing Page"
          color="primary"
          shape="round"
          :disabled="isBuildDisabled"
          :loading="loading"
          @click="handleBuildFunnel"
        />
      </div>
    </section>
  </div>
  <div class="content-wrapper position-relative">
    <div ref="previewPane" class="preview-pane">
      <div
        :class="{
          content: true,
        }"
      >
        <div v-if="!siteId || !pageId" class="preview-placeholder">
          <span
            >Fill your business details to generate your landing page...</span
          >
        </div>
        <iframe
          v-else
          :src="previewUrl"
          class="preview-iframe"
          frameborder="0"
          width="100%"
          height="100%"
        ></iframe>

        <!-- Floating Use Template Button -->
        <cvt-button
          v-if="siteId && pageId"
          class="use-template-btn"
          text="Use this template"
          color="primary"
          shape="round"
          @click="useTemplate"
        />
      </div>
    </div>
  </div>
</GenAILayout>
